import {
  TBrand,
  TBrandDetail,
  TBrandUpdate,
  TNewBrandCreate,
  TStoreUiConfigResponse,
  TUiConfigPayload
} from 'types/brand';
import { TEmployeeCreate } from 'types/employee';
import { BaseReponse } from 'types/response';
import { StoreReport, TStore, TStoreCreate, TStoreDetail } from 'types/store';

import requestWebAdmin from 'utils/axios';
import { generateAPIWithPaging } from './utils';

const getBrandDetail = (brandId: string) => requestWebAdmin.get<TBrandDetail>(`brands/${brandId}`);

const getStoreOfBrand = (brandId: string, params?: any) => {
  return requestWebAdmin.get<BaseReponse<TStore>>(`brands/${brandId}/stores`, { params });
};

const checkBrandHasBaseMenu = (brandId: string) => {
  return requestWebAdmin.get<{ hasBaseMenu: boolean }>(`brands/${brandId}/menus/hasBaseMenu`);
};

const getStoresOfBrandWithoutPaging = () => {
  return requestWebAdmin.get<BaseReponse<TStoreDetail>>(`brands/stores`);
};

const getListUserOfBrand = (brandId: string, params?: any) => {
  return requestWebAdmin.get<BaseReponse<any>>(`brands/${brandId}/users`, { params });
};
const createUserOfBrand = (brandId: string, values: TEmployeeCreate) => {
  return requestWebAdmin.post<BaseReponse<any>>(`brands/${brandId}/users`, values);
};

const createNewBrand = (data: TNewBrandCreate) => {
  return requestWebAdmin.post<BaseReponse<TBrandDetail>>('brands', data);
};

const updateBrandInformation = (brandId: string, values: TBrandUpdate) => {
  return requestWebAdmin.patch<BaseReponse<TBrandDetail>>(`brands/${brandId}`, values);
};

const createNewBrandStore = (data: TStoreCreate) => {
  return requestWebAdmin.post<BaseReponse<TStoreDetail>>('stores', data);
};
const getBrandReport = (params: any) =>
  requestWebAdmin.get<StoreReport>(`brands/day-report`, { params: params });
const getBrandProductReport = (params: any) =>
  requestWebAdmin.get<StoreReport>(`brands/product-report`, { params: params });

const getBrandUiConfig = (brandId: string) =>
  requestWebAdmin.get<TStoreUiConfigResponse>(`brands/${brandId}/ui-config`);

const upsertBrandUiConfig = (brandId: string, payload: TUiConfigPayload) =>
  requestWebAdmin.put<TStoreUiConfigResponse>(`brands/${brandId}/ui-config`, payload);

const getStoreUiConfig = (brandId: string, storeId: string) =>
  requestWebAdmin.get<TStoreUiConfigResponse>(`brands/${brandId}/stores/${storeId}/ui-config`);

const upsertStoreUiConfig = (brandId: string, storeId: string, payload: TUiConfigPayload) =>
  requestWebAdmin.put<TStoreUiConfigResponse>(
    `brands/${brandId}/stores/${storeId}/ui-config`,
    payload
  );

const brandApi = {
  getBrandDetail,
  getStoreOfBrand,
  checkBrandHasBaseMenu,
  getListUserOfBrand,
  createUserOfBrand,
  createNewBrand,
  updateBrandInformation,
  createNewBrandStore,
  getStoresOfBrandWithoutPaging,
  getBrandReport,
  getBrandProductReport,
  getBrandUiConfig,
  upsertBrandUiConfig,
  getStoreUiConfig,
  upsertStoreUiConfig,
  ...generateAPIWithPaging<TBrand>('brands')
};

export default brandApi;
